import { render, staticRenderFns } from "./BaseTipBox.vue?vue&type=template&id=6505d7c5&scoped=true"
import script from "./BaseTipBox.vue?vue&type=script&lang=js"
export * from "./BaseTipBox.vue?vue&type=script&lang=js"
import style0 from "./BaseTipBox.vue?vue&type=style&index=0&id=6505d7c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6505d7c5",
  null
  
)

export default component.exports